<script lang="ts">
    import { Col,Alert, Button} from "sveltestrap";
    import { dismiss, Textasaction, TextasactionMessage } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Alert/Alert.json"
    let visible:boolean = true;
    let visible1:boolean = true
    let data1=data.Textasactiondata
    const visibilty = (id:string) =>{
      let datas:any =  data1.filter((alldata:any)=>{
         return id !== alldata.target
        })
        data1 = datas
    }
</script>
<Col sm="12" xl="6">
    <Card cardHeader2props="pb-0" CardBodyprops="dismiss-text">
      <div slot="customHeader2">
        <h5>{Textasaction}</h5>
        <span>{@html TextasactionMessage}</span>
      </div>
      <div slot="contentbody">
        <Alert dismissible color="primary" class="inverse fade show" isOpen={visible1}>
            <i class="icon-timer"></i>
            <p>Your time Over after <b>5</b> miniute</p>
            <Button class="btn-close" color="" on:click={()=>(visible1 = !visible1)}>
                <span class="bg-primary">{dismiss}</span>
            </Button>
        </Alert>
        {#each data1 as alertItem}
            <Alert dismissible color={alertItem.color} class="inverse fade show" isOpen={visible} target={alertItem.target} >
                <i class={alertItem.icon}></i>
                <p>{alertItem.title}</p>
                <Button class="btn-close" color="" on:click={()=>visibilty(alertItem.target)} >
                    <span class="bg-{alertItem.color} {alertItem.class}">{dismiss}</span>
                </Button>
            </Alert>
        {/each}
      </div>
    </Card>
</Col>